import COLORS from './colors';

const customerByLoginsChartConfig = {
  name: 'customers_by_login',
  title: 'Login Frequency',
  metric: 'customers_by_login',
  linesColor: COLORS.red,
  downloadUsingLineLabels: false,
  lines: {
    customers_by_login: {
      label: 'Login',
      position: 1,
      color: COLORS.red,
    },
  },
};

export default customerByLoginsChartConfig;
